<template>
  <div class="company-detail-base">
    <div class="base-item">
      <div class="title">{{$t('crm_partner_detail_base_personal.ji_chu_xin_xi')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_detail_base_personal.gong_si_lei_xing')}}</div>
          <div class="val">{{ getDicValue('bas_org_type', data.partnerType) }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_detail_base_personal.gong_si_bian_hao')}}</div>
          <div class="val">{{  data.partnerCode }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_detail_base_personal.shou_ji_hao_ma')}}</div>
          <div class="val">{{ data.telephone }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_detail_base_personal.you_xiang')}}</div>
          <div class="val">{{ data.email }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col long">
          <div class="key">{{$t('crm_partner_detail_base_personal.ju_zhu_di_zhi')}}</div>
          <div class="val">{{ [data.country, data.province, data.city].join("")
            }}{{ data.detailAddress }}</div>
        </div>
      </div>
    </div>
    <div class="base-item">
      <div class="title">{{$t('crm_partner_detail_base_personal.sfzxx')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_detail_base_personal.xing_ming')}}</div>
          <div class="val">{{ data.legalPerson }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_detail_base_personal.shen_fen_zheng_hao')}}</div>
          <div class="val">{{ data.legalPersonIdentity }}</div>
        </div>

        <div class="col">
          <div class="key">{{$t('crm_partner_detail_base_personal.zheng_jian_zhao')}}</div>
          <div class="val">
            <span class="detail" @click="visible2 = true">{{$t('Common.com_detail')}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="base-item">
      <div class="title">{{$t('crm_partner_detail_base_personal.guan_li_yuan_xin_xi')}}</div>
      <div class="table-bd">
        <custom-table
          :data="tableList"
          :column="tableColumn"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
    </div>
    <img-detail-dialog
      :bizData="idPhotoData"
      :title="$t('crm_partner_detail_base_personal.zheng_jian_zhao')"
      v-if="visible2"
      @close="visible2 = false"
    ></img-detail-dialog>
    <img-detail-dialog
      :bizData="licenseData"
      :title="$t('crm_partner_detail_base_personal.zjhdcsfrdjzs')"
      v-if="visible"
      @close="visible = false"
    ></img-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: String
  },
  computed: {
    // 证件照biz数据
    idPhotoData() {
      return [
        // 身份证人像面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.face'
        },
        // 身份证国徽面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.reverse'
        }
      ];
    },
    // 营业执照biz数据
    licenseData() {
      return [
        {
          bizId: this.partnerId,
          bizType: 'crm.partner.license'
        }
      ];
    }
  },
  // watch: {
  //   data(val) {
  //     if (val && val.orgId) {
  //       this.getTableList();
  //     }
  //   }
  // },
  data() {
    return {
      // 营业执照图片
      visible: false,
      // 证件照
      visible2: false,
      tableCode: 'company_admin_info',
      tableList: []
    };
  },
  methods: {
    getTableList() {
      this.$getJSON(`${apis.partnerOrganAdminItem}/${this.data.partnerOrgId}`).then(
        (res) => {
          this.tableList = [res.data];
        }
      );
    }
  },
  mounted() {
    this.getTableColumn();
    this.getTableList();
  }
};
</script>

<style lang="scss" scoped>
.company-detail-base {
  padding-left: 40px;
  padding-right: 24px;
  .base-item {
    font-size: 12px;
    padding-bottom: 32px;
    border-bottom: 1px solid #eef2f8;

    &:nth-child(n + 2) {
      margin-top: 7px;
    }

    overflow: hidden;
    .title {
      color: #0d9ae0;
      font-weight: bold;
      line-height: 16px;
      margin-top: 24px;
    }
    .row {
      overflow: hidden;
      .col {
        float: left;
        width: 250px;
        margin-top: 24px;
        &.long {
          width: 100%;
        }
        .key {
          color: #98a6ad;
          line-height: 16px;
        }
        .val {
          margin-top: 8px;
          font-weight: bold;
          color: #495057;
        }
        .detail {
          color: #0d9ae0;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    .table-bd {
      margin-top: 24px;
    }
  }
}
</style>
